import React from 'react';
import styles from './styles';
import './footer.css';

import {  Carousel, Button, Row, Col } from 'antd';
import {EnvironmentOutlined, PhoneOutlined, MailOutlined, DashboardOutlined, FacebookOutlined, TwitterOutlined,
    LinkedinOutlined, GooglePlusOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';

const Footer = () => {
    return(
        <>
         <div style={{minHeight: '80vh'}} className="footer">
          <div className="container" style={styles.footerDiv}>
            <Row>
                <Col xs={24} sm={12} md={12} lg={8} style={styles.footerCol}>
                <EnvironmentOutlined style={styles.footerIcon}/>
                    <h2 style={styles.footerHeading}>address</h2>
                    <p style={styles.footerPara}>HassanAbad, Jutal, Gilgit, Gilgit-Baltistan, Pakistan</p>
                </Col>
                <Col xs={24} sm={12} md={12} lg={8} style={styles.footerCol}>
                <PhoneOutlined style={styles.footerIcon}/>
                    <h2 style={styles.footerHeading}>call us</h2>
                    <p style={styles.footerPara} className="footerPara"><span>+91 3115845815</span><br /> 
                  <span>+91 3119776697</span> <br />
                  <span>+91 3112310525</span></p>
                </Col>
                <Col xs={24} sm={12} md={12} lg={8} style={styles.footerCol}>
                <MailOutlined style={styles.footerIcon}/>
                    <h2 style={styles.footerHeading}>email us</h2>
                    <p style={styles.footerPara} className="footerPara"><span>broshallfishfarms@gmail.com</span>
                    <br /><span>muhammadissapasha@gmail.com</span></p>
                </Col>
                {/* <Col xs={24} sm={12} md={12} lg={8} style={styles.footerCol}>
                <DashboardOutlined style={styles.footerIcon}/>
                    <h2 style={styles.footerHeading}>working hours</h2>
                    <p style={styles.footerPara} className="footerPara">Mon-Sat :<span>9:00 AM TO 5:00 PM</span>
                    <br />Sun :<span>9:00 Am To 2:00 PM</span></p>
                </Col> */}
            </Row>
          </div>
            <div className="container">
            <Row>
                <hr style={styles.separator}/>
                <Col xs={24} sm={12} md={15} lg={16} style={styles.footerCol} className="footer-fishing">
                    <h2 style={styles.footerHeading}>Our Mission</h2>
                    <p style={styles.footerPara} className="footer-para">Beats all you've ever saw been in trouble with the law since the day they was born.
                     Believe it or not I'm walking on air. I never thought I could feel so free.</p>
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} style={styles.footerCol} className="footer-col">
                    <h2 style={styles.footerHeading}>subscribe</h2>
                    <div style={styles.subscribeDiv} className="footer-input">
                    <input type="text" placeholder="Email Address" style={styles.footerInput} />
                    <button style={styles.footerBtn} className="footer-btn">GO</button>
                    </div>
                </Col>
                <hr style={styles.separator}/>
            </Row>
            <Row style={{marginTop: '30px'}}>
                <Col xs={24} sm="12" md={13} lg={16}>
                <p style={styles.footerPara}>© Copyright 2021. All Rights Reserved</p>
                </Col>
                <Col xs={24} sm="12" md={12} lg={8}>
                <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                     <a href="#"><FacebookOutlined style={styles.footerIcond}/></a>
                     <a href="#"><TwitterOutlined style={styles.footerIcond}/></a>
                     <a href="#"><LinkedinOutlined style={styles.footerIcond}/></a>
                     <a href="#"><GooglePlusOutlined style={styles.footerIcond}/></a>
                  </div>
                </Col>
            </Row>
            </div>
          </div>
        </>
    )
}

export default Footer;